export default __webpack_public_path__ + "static/media/product-23.5b110d4e.jpg";